exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2CDYNTq84xSL54fjNsJbsX{color:#ff3940;padding:30px}._5agfqT-kcKpHooaRnTvsL{padding:30px}._3aLmiHjoFxcyHA-qX3rDlP{opacity:0.4}._39MD5ej4LeSwEWvtbadEau{opacity:1}._339ngM-NKLvWiDYD75RqHk{font-weight:bold;margin-top:20px}\n", ""]);

// Exports
exports.locals = {
	"error": "_2CDYNTq84xSL54fjNsJbsX",
	"result": "_5agfqT-kcKpHooaRnTvsL",
	"code": "_3aLmiHjoFxcyHA-qX3rDlP",
	"highlightedCode": "_39MD5ej4LeSwEWvtbadEau",
	"headLite": "_339ngM-NKLvWiDYD75RqHk"
};